function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "19",
  height: "13",
  viewBox: "0 0 19 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.248 3.409c-.527-.849-1.315-1.482-1.952-1.891l2.372-.643a4.617 4.617 0 112.415 8.914l-2.667.723a4.618 4.618 0 01-5.5-6.162l.126.038c.302.092.687.208 1.055.388.474.233.796.514.884.855a2.266 2.266 0 002.82 2.611l2.667-.723a2.266 2.266 0 00-1.185-4.374l-1.081.293.046-.03zm-2.885 1.33a2.257 2.257 0 011.252-.872l.846-.229c-.633-.898-1.617-1.513-2.159-1.79a4.603 4.603 0 00-2.03 1.79c.303.092.753.23 1.17.435.317.155.66.369.92.666z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.445.877l2.619.885a4.618 4.618 0 012.974 5.594c-.715.254-1.18.216-1.49.071-.32-.15-.558-.452-.733-.89A2.267 2.267 0 008.31 3.99l-2.618-.886A2.266 2.266 0 104.24 7.398l1.984.67c.686 1.149 1.385 2.03 2.231 2.604a4.596 4.596 0 01-2.35-.161l-2.618-.886A4.618 4.618 0 116.445.877zm3.035 9.47a4.608 4.608 0 002.202-2.08c-.565.11-1.052.064-1.466-.13a2.013 2.013 0 01-.791-.677 2.27 2.27 0 01-2.066.932c.589.858 1.17 1.448 1.827 1.81.096.053.194.101.294.145z",
  fill: "#fff"
})));